module.exports = __webpack_public_path__ + "static/img/tab1-active.2f1f5f77.png";